// components imports
import Svg from "../assets/Svgs/Svg";
// library imports
import CountUp from "react-countup";
import { Container, Row } from "react-bootstrap";
// data imports
import { data } from "../Data/data";
import Animation from "../animations/Animation";

const Counter = () => {
   return (
      <Animation slide bottom>
         <Container>
            <Row className="counter-section mt40 mb40">
               <>
                  {data.counter.map((elem, i) => {
                     return (
                        <div key={i} className="count-number" style={{ flex: "0 0 auto", width: "20%" }}>
                           <div className="d-flex flex-column justify-content-center font-sm-25 font-md-40 font-65 font-weight-500">
                              <div>
                                 <CountUp style={{ fontFamily: "DMSans-font" }} end={elem.count} enableScrollSpy={true} scrollSpyOnce={true} className="count" />
                                 <span className="count" style={{ fontFamily: "DMSans-font" }}>
                                    {Svg.plus}
                                 </span>
                              </div>
                              <h6 className="font-weight-600">{elem.description}</h6>
                           </div>
                        </div>
                     );
                  })}
               </>
            </Row>
         </Container>
      </Animation>
   );
};

export default Counter;
